"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventBus = exports.FormBuilderAction = void 0;
const event_bus_1 = require("@pulse-web-platform-core/event-bus");
var FormBuilderAction;
(function (FormBuilderAction) {
    FormBuilderAction["UPDATE_FORM"] = "update-form";
    FormBuilderAction["UPDATE_FORM_ERRORS"] = "update-form-errors";
    FormBuilderAction["SUBMIT_FORM"] = "submit-form";
    FormBuilderAction["AUTH_USER"] = "auth-user";
})(FormBuilderAction || (exports.FormBuilderAction = FormBuilderAction = {}));
exports.eventBus = new event_bus_1.EventBus();
